<script setup lang="ts">
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/24/outline';
import CaseIdsPanel from './CaseIdsPanel.vue';

defineProps<{
  caseId: string;
  accountId?: string;
  externalId: string;
  externalCheckId?: string;
  createdAt: string;
  lastSavedAt?: string | null;
  lastReviewedBy?: string | null;
  completedAt?: string | null;
  supersedingAmlReviewId?: string;
}>();
</script>

<template>
  <Popover as="div" class="relative">
    <PopoverButton
      data-test="btn-case-ids"
      class="inline-flex items-center gap-1 text-[11.5px] font-medium text-indigo-600 hover:text-indigo-700"
    >
      Details
      <ChevronDownIcon class="size-3.5" />
    </PopoverButton>
    <PopoverPanel
      class="absolute left-0 z-30 mt-1 w-[22rem] rounded-xl border border-gray-200 bg-white shadow-lg focus:outline-none"
    >
      <CaseIdsPanel
        :case-id="caseId"
        :account-id="accountId"
        :external-id="externalId"
        :external-check-id="externalCheckId"
        :created-at="createdAt"
        :last-saved-at="lastSavedAt"
        :last-reviewed-by="lastReviewedBy"
        :completed-at="completedAt"
        :superseding-aml-review-id="supersedingAmlReviewId"
      />
    </PopoverPanel>
  </Popover>
</template>
